import { useEffect, useState } from "react";

import { apiGet } from "@/services/api";

type Review = {
  id: string;
  rating: number;
  title: string;
  comment: string;
  createdAt: string;
  user: { name: string | null } | null;
  product: { title: string } | null;
};

export function VendorReviewsPage() {
  const [reviews, setReviews] = useState<Review[]>([]);
  useEffect(() => {
    void apiGet<{ reviews: Review[] }>("/api/vendors/me/reviews").then((d) => setReviews(d?.reviews ?? []));
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Reviews</h2>
      <div className="amazon-card divide-y divide-slate-100 dark:divide-white/10">
        {reviews.length === 0 && <p className="p-6 text-sm text-slate-500">No reviews yet.</p>}
        {reviews.map((r) => (
          <div key={r.id} className="p-4">
            <p className="font-bold">
              {"★".repeat(r.rating)} {r.title}
            </p>
            <p className="text-sm text-slate-600 dark:text-slate-300">{r.comment}</p>
            <p className="mt-1 text-xs text-slate-500">
              {r.user?.name ?? "Customer"} · {r.product?.title ?? "Product"} · {new Date(r.createdAt).toLocaleDateString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
